import React, { useState } from 'react';
import './list.css';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import SingleValue from './single-value';

const Nested = (props) => {
    const [subOpen, setSubOpen] = useState(false);
    const [label, setLabel] = useState(props.label);
    const [value, setValue] = useState(props.propertyValue);
    const [newObject] = useState(JSON.parse(JSON.stringify(props.propertyValue)));
    const [nestedEditFlag] = useState([]);
    const [error, setError] = useState(false);

    const handleSubClick = () => {
        setSubOpen(!subOpen);
    };

    React.useEffect(() => {
        setLabel(props.label);
        setValue(props.propertyValue);
        setError(props.error)
    }, [props.label, props.propertyValue, props.error]);

    /**
     * check All validation for Nested attribute
     * @returns final flag
     */
    const checkAndSendFlag = () => {
        let overAllFlag = false;
        if (nestedEditFlag.length === 0) {
            return false;
        } else {
            nestedEditFlag.forEach((object) => {
                Object.keys(object).forEach((attributeName) => {
                    overAllFlag = overAllFlag || object[attributeName]
                })
            })
        }
        return overAllFlag;
    }

    /**
     * Update the DCR changes
     * @param {*} value 
     * @param {*} flag 
     * @param {*} labelName 
     * @param {*} index 
     */
    const updateValue = (value, flag, labelName, index) => {
        nestedEditFlag.splice(index, 1, { ...nestedEditFlag[index], [labelName]: flag });
        newObject.splice(index, 1, { ...newObject[index], [labelName]: [value] });
        props.updatedValue(newObject, checkAndSendFlag());
    }
    return (
        <>
            {
                value !== undefined && typeof value === 'object' && !Array.isArray(value) &&
                < List component="nav"
                    className="bg-grey py-0" >
                    <ListItem onClick={handleSubClick} className='ps-0 py-0'>
                        {subOpen ? <ExpandLess /> : <ArrowForwardIosIcon style={{ fontSize: 15 }} />}
                        <ListItemText className="text-muted " primary={label} />
                    </ListItem>
                    <Collapse in={subOpen} timeout="auto" unmountOnExit>
                        {
                            Object.keys(value).map((key, i) => {
                                const formattedLabel = key.replace(/([a-z])([A-Z])/g, '$1 $2');
                                return (
                                    <List key={i} component="div" disablePadding >
                                        <ListItem className='py-0'>
                                            {
                                                <SingleValue
                                                    error={error}
                                                    mode={props.mode}
                                                    key={'obj' + i}
                                                    label={formattedLabel}
                                                    value={Array.isArray(value[key]) ? value[key] : [{value: value[key].toString()}]}
                                                    updatedValue={(value, flag) => updateValue(value, flag, key, 0)}
                                                    entity={props.entity}
                                                />
                                            }
                                        </ListItem>
                                    </List>
                                )
                            }
                            )
                        }
                    </Collapse>
                </List >
            }
            {
                value !== undefined && value.length > 0 &&
                < List component="nav"
                    className="bg-grey py-0" >
                    <ListItem onClick={handleSubClick} className='ps-0 py-0'>
                        {subOpen ? <ExpandLess /> : <ArrowForwardIosIcon style={{ fontSize: 15 }} />}
                        <ListItemText className="text-muted " primary={label} />

                    </ListItem>
                    <Collapse in={subOpen} timeout="auto" unmountOnExit>
                        {

                            value !== undefined && value.map((arrayZip, key) => {
                                let zipValues = Object.keys(arrayZip);
                                zipValues.sort();

                                return (
                                    <div key={key} className='border m-1'>
                                        {
                                            zipValues.map((zip, i) => {
                                                if (zip !== 'ov') {
                                                    return (
                                                        <List key={i} component="div" disablePadding >
                                                            <ListItem className='py-0'>
                                                                <SingleValue
                                                                    error={error}
                                                                    mode={props.mode}
                                                                    key={'zip' + i} label={zip}
                                                                    value={arrayZip[zip]}
                                                                    updatedValue={(value, flag) => updateValue(value, flag, zip, key)}
                                                                    entity = {props.entity}
                                                                />
                                                            </ListItem>
                                                        </List>
                                                    )
                                                } else {
                                                    return '';
                                                }
                                            })
                                        }
                                    </div>

                                )
                            })
                        }
                    </Collapse>
                </List >
            }
        </>
    )

}

export default Nested;